<template>
<div>
  <el-dropdown>
  <span class="el-dropdown-link">
    <button
      title="Ações"
      :class="classBtnAction"
    >
      <i class="ti-more-alt"></i>
        <span v-if="showLabel">
          Ações
        </span>
    </button>
  </span>
    <el-dropdown-menu slot="dropdown">
      <dropdown-item-children :children="children"/>
    </el-dropdown-menu>
  </el-dropdown>
</div>
</template>

<script>
import DropdownItemChildren from './DropdownItemChildren'

export default {
  name: 'actions-table-layout',
  components: { DropdownItemChildren },
  props: {
    colorBtn: {
      default: 'btn-default'
    },
    showLabel: {
      default: false,
      type: Boolean
    },
    children: {
      required: true
    }
  },

  computed: {
    classBtnAction: function () {
      return 'btn btn-fill dropdown-toggle btn-icon ' + this.colorBtn
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Layout/ActionsTableLayout.vue